import React, { useState } from 'react';
import { Tab, Tabs } from '@mui/material';
import FullScreenButton from './FullScreenButton';
import CompanyInfoGrid, {
  CONTAINER_CARRIER_COLLECTION,
  DISPATCH_COMPANY_COLLECTION,
} from './CompanyInfoGrid';

interface CompanyInfoPageProps {
  isFullScreen: boolean;
  setIsFullScreen: (v: boolean) => void;
}

const CompanyInfoPage: React.FC<CompanyInfoPageProps> = ({ isFullScreen, setIsFullScreen }) => {
  const [tab, setTab] = useState(0);

  return (
    <div
      tabIndex={0}
      style={{
        width: '100%',
        maxWidth: '100%',
        margin: 0,
        padding: '12px 10px',
        display: 'flex',
        flexDirection: 'column',
        height: isFullScreen ? '100vh' : 'calc(100vh - 48px)',
        overflow: 'hidden',
        boxSizing: 'border-box',
      }}
    >
      <div style={{ flex: '0 0 auto' }}>
        <h2 style={{ textAlign: 'center', marginBottom: 16, color: '#1976d2' }}>거래처정보 관리</h2>
        <Tabs
          value={tab}
          onChange={(_, v) => setTab(v)}
          sx={{ borderBottom: 1, borderColor: 'divider', mb: 1, minHeight: 40 }}
        >
          <Tab label="거래처정보" />
          <Tab label="컨테이너 운송업체" />
        </Tabs>
      </div>

      <div style={{ flex: '1 1 0', minHeight: 0, display: 'flex', flexDirection: 'column' }}>
        {tab === 0 && <CompanyInfoGrid collectionName={DISPATCH_COMPANY_COLLECTION} />}
        {tab === 1 && <CompanyInfoGrid collectionName={CONTAINER_CARRIER_COLLECTION} />}
      </div>

      <FullScreenButton isFullScreen={isFullScreen} setIsFullScreen={setIsFullScreen} />
    </div>
  );
};

export default CompanyInfoPage;
